module.exports = __webpack_public_path__ + "media/hk_3F RM7.5abda3fe.mp4";